import React from 'react';
import { cn } from '../../design-system/cn';
import { liveIndicator } from '../../design-system/tokens/status';

/**
 * LiveIndicator — minimal pulsing dot + LIVE label.
 * For period/quarter detail use LiveGamePeriodBadge (canonical in game cards).
 */
export default function LiveIndicator({
  size = 'md',
  showLabel = true,
  className,
  label = 'Live',
}) {
  const dotClass = size === 'sm' ? liveIndicator.dotSm : liveIndicator.dot;

  return (
    <span className={cn(liveIndicator.root, className)} role="status">
      <span className={dotClass} aria-hidden />
      {showLabel && (
        <span className={liveIndicator.label}>{label}</span>
      )}
    </span>
  );
}
